import React from 'react';
import { PreFormattedList } from './generic/PreFormattedList';

interface Iprops {
    data: string,
}

export const GreatestGames = (props: Iprops) => {
    const { data } = props;

    return (
        <PreFormattedList data={data} />
    )
}